import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["draggable", "onClick", "onDragstart", "onDrop"]
const _hoisted_5 = { key: 0 }

import {OrderLine} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {nextTick} from "vue"
  import Button from "@/components/button.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'order_line',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "items": {
    default: null,
    required: true,
    type: Array<OrderLine>
  },
    "itemsModifiers": {},
    "selectedIndex": {
    default: null,
    required: false,
    type: Number
  },
    "selectedIndexModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:items", "update:selectedIndex"]),
  setup(__props, { emit: __emit }) {

  

  const emits = __emit

  const items = _useModel(__props, "items")

  const selectedIndex = _useModel(__props, "selectedIndex")

  async function select(index: number) {
    selectedIndex.value = index
    await nextTick()
    emits("select")
  }

  function dragStart(event: DragEvent, index: number) {
    event.dataTransfer.dropEffect = "move"
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("INDEX", index.toString())
  }

  function drop(event: DragEvent, index: number) {
    const startIndex = parseInt(event.dataTransfer.getData("INDEX"))
    items.value.splice(index, 0, items.value.splice(startIndex, 1)[0])
    updatePriority()
  }

  function updatePriority() {
    for (const [index, orderLine] of items.value.entries()) {
      orderLine.priority = index
    }
  }

  function remove(event: MouseEvent, index: number) {
    event.stopPropagation()
    items.value[index].deletedAt = new Date().toISOString()
  }

  function add() {
    items.value.push({})
    updatePriority()
    select(items.value.length - 1)
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (items.value)
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (!__props.readOnly)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_2, [
                      _createVNode(Button, {
                        title: "Add",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
                      })
                    ]))
                  : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createElementVNode("th", null, " Amount ", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("th", null, " Description ", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("th", null, " Subtotal Price ", -1))
              ])
            ]),
            (items.value.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (orderLine, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: orderLine.id
                    }, [
                      (!orderLine.deletedAt)
                        ? (_openBlock(), _createElementBlock("tr", {
                            key: 0,
                            draggable: !__props.readOnly,
                            onClick: ($event: any) => (select(index)),
                            onDragstart: ($event: any) => (dragStart($event, index)),
                            onDrop: ($event: any) => (drop($event, index)),
                            onDragenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                            onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                          }, [
                            (!__props.readOnly)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                                  _createVNode(Button, {
                                    title: "Remove",
                                    onClick: ($event: any) => (remove($event, index))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, _toDisplayString(orderLine.amount), 1),
                            _createElementVNode("td", null, _toDisplayString(orderLine.description), 1),
                            _createElementVNode("td", null, [
                              (orderLine.price)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(orderLine.price.grossTotal.toFixed(2)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ], 40, _hoisted_4))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})